import { motion } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

// ✅ TS-safe easing
const easeOutBezier: [number, number, number, number] = [0.16, 1, 0.3, 1];

const FoundersMessage: React.FC<{ content?: any }> = ({ content }) => {
  const { t_api } = useLanguage();
  const introTitle = t_api(content?.intro_title || "About • Message", content?.intro_title_ar);
  const title = t_api(content?.title || "Founder’s Message", content?.title_ar);
  const welcomeText = t_api(content?.welcomeText || "Welcome to Hamdan Trading Group", content?.welcomeText_ar);
  const message = t_api(content?.message || "Travelling down the memory lane to the 1975s...", content?.message_ar);
  const signature = {
    name: t_api(content?.signature?.name || "Hamed bin Hamood Al Ghafri", content?.signature?.name_ar),
    role: t_api(content?.signature?.role || "Founder & Chairman", content?.signature?.role_ar),
  };

  return (
    <section className="bg-white">
      {/* SECTION WRAPPER */}
      <motion.div
        className="max-w-7xl mx-auto px-6 py-10"
        initial={{ opacity: 0, scale: 0.98 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: easeOutBezier }}
        viewport={{ once: true, amount: 0.3 }}
      >
        {/* Header */}
        <motion.div
          className="mb-10"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: easeOutBezier }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <p className="text-xs uppercase tracking-widest text-red-500 font-semibold">
            {introTitle}
          </p>
          <h1 className="mt-5 text-2xl md:text-3xl font-extrabold text-[#0B1220]">
            {title}
          </h1>
        </motion.div>

        {/* Content Card */}
        <motion.div
          className="rounded-3xl border border-gray-200 bg-gray-50 p-8 md:p-10 "
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: easeOutBezier }}
          viewport={{ once: true, amount: 0.25 }}
          whileHover={{ y: -2, boxShadow: "0 12px 30px rgba(0,0,0,0.08)" }}
        >
          <motion.h2
            className="text-lg font-bold text-[#0B1220] mb-4"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: easeOutBezier }}
            viewport={{ once: true, amount: 0.5 }}
          >
            {welcomeText}
          </motion.h2>

          {/* MESSAGE PARAGRAPHS */}
          <div className="space-y-5 text-gray-700 leading-relaxed text-justify text-[15px] sm:text-sm md:text-base">
            <div dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, '<br/>') }} />
          </div>

          {/* Signature */}
          <motion.div
            className="mt-8 pt-6 border-t border-gray-200"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: easeOutBezier }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <p className="text-sm text-gray-600">{t_api("Sincerely,")}</p>
            <p className="mt-2 text-base font-semibold text-[#0B1220]">
              {signature.name}
            </p>
            <p className="text-sm font-medium text-[#C1121F]">
              {signature.role}
            </p>
          </motion.div>
        </motion.div>
      </motion.div>
    </section >
  );
};

export default FoundersMessage;
